export default __webpack_public_path__ + "static/media/HelveticaNeueMedium.2600e9d5.woff2";